/**
 * Created by Phatbass on 21/02/16.
 */

'use strict';

// TODO: Add all urls
angular.module('far.models.committee', [])
    .service('Committee', function ($log, $http) {
        var list = [],
            firstListQuery = true,
            listQueryProgress = false;

        Object.defineProperty(this, 'list', {
            get: function () {
                if (firstListQuery && !listQueryProgress) {
                    listQueryProgress = true;
                    $http.get(Routing.generate('api_committee_get_committees'))
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                item.selected = false;
                                list.push(item);
                            });

                            firstListQuery = false;
                            listQueryProgress = false;
                        })
                        .catch(function (response) {
                            $log.error(response);
                            listQueryProgress = false;
                        });
                }

                return list;
            }
        });

        this.new = function (data) {
            return new Committee(data);
        };

        this.get = function (routeId, callback) {
            var route = new Committee({});

            $http.get(Routing.generate('api_committee_get_committee', {committee: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function Committee(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method  = 'put',
                            url     = Routing.generate('api_committee_put_committee', {committee: this.id});

                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        return $http[method](url, data);
                    }
                }
            });
        }

    });